<p>Menopause affects <strong>1.2 billion</strong> women globally each year, and yet it takes on average <strong>6-7 years</strong> to get diagnosed, and 66% end up with <strong>incorrect treatment plans</strong>.</p>
<p>The perimenopause can begin up to <strong>15 years</strong> before periods stop. Symptoms - from brain fog and hot flushes, to fatigue and anxiety - can <strong>significantly reduce quality of life</strong>. The <strong>immune system is affected too</strong>, increasing the risk of osteoporosis, dementia, cardiovascular disease and even cancer.</p>
<p>The all-female team behind MenoAge set out to help. We empower women to live healthier lives, for longer.</p>

<style>
  p {
    font-size: min(2.25rem, calc(8px + 2.5vw));
    line-height: 1.75;
    margin: 3em 0;
  }
  
  strong {
    background: #B4B2F9;
    font-weight: normal;
  }
</style>
